"use client";

import { Link } from "@/components/common/Link";
export default function PrivacyPolicySection() {
  return <section className="bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {}
      </div>
    </section>;
}